
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"storeCustomerPba"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bank_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sanction_bg_lc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sanction_tl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sanction_cc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oa_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oa_bg_lc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oa_tl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oa_cc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oa_roi"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oa_asset_classification"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"newCustomerPba"},"name":{"kind":"Name","value":"storeCustomerPba"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customer_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"bank_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bank_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"sanction_bg_lc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sanction_bg_lc"}}},{"kind":"Argument","name":{"kind":"Name","value":"sanction_tl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sanction_tl"}}},{"kind":"Argument","name":{"kind":"Name","value":"sanction_cc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sanction_cc"}}},{"kind":"Argument","name":{"kind":"Name","value":"oa_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oa_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"oa_bg_lc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oa_bg_lc"}}},{"kind":"Argument","name":{"kind":"Name","value":"oa_tl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oa_tl"}}},{"kind":"Argument","name":{"kind":"Name","value":"oa_cc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oa_cc"}}},{"kind":"Argument","name":{"kind":"Name","value":"oa_roi"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oa_roi"}}},{"kind":"Argument","name":{"kind":"Name","value":"oa_asset_classification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oa_asset_classification"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerPbaFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":708}};
    doc.loc.source = {"body":"#import \"../fragments/CustomerPbaFragment.graphql\"\n\nmutation storeCustomerPba (\n  $customer_id: Int!\n  $bank_name: String!\n  $sanction_bg_lc: Float!\n  $sanction_tl: Float!\n  $sanction_cc: Float!\n  $oa_date: String!\n  $oa_bg_lc: Float!\n  $oa_tl: Float!\n  $oa_cc: Float!\n  $oa_roi: Float!\n  $oa_asset_classification: String\n) {\n  newCustomerPba: storeCustomerPba (\n    customer_id: $customer_id\n    bank_name: $bank_name\n    sanction_bg_lc: $sanction_bg_lc\n    sanction_tl: $sanction_tl\n    sanction_cc: $sanction_cc\n    oa_date: $oa_date\n    oa_bg_lc: $oa_bg_lc\n    oa_tl: $oa_tl\n    oa_cc: $oa_cc\n    oa_roi: $oa_roi\n    oa_asset_classification: $oa_asset_classification\n  ) {\n    ...CustomerPbaFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/CustomerPbaFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["storeCustomerPba"] = oneQuery(doc, "storeCustomerPba");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/mutations/storeCustomerPbaMutation.graphql
// module id = 1406
// module chunks = 0